import Exercise from "./Exercise"

class ExerciseStore {
  static #KEY = 'gimeExercises'

  static getAll() {
    return ExerciseStore.#load().filter(e => !e.deletedAt)
  }

  static getAllByType() {
    const grouped = {}
    ExerciseStore.getAll().forEach((exercise) => {
      const type = exercise.exerciseType
      if (!grouped[type]) {
        grouped[type] = []
      }
      grouped[type].push(exercise)
      grouped[type].sort((a, b) => {
        return a.exerciseName.toLowerCase().localeCompare(b.exerciseName.toLowerCase())
      })
    })
    return grouped
  }

  static get(id) {
    return ExerciseStore.#load().find(e => e.id === id) ?? null
  }

  static create(exercise) {
    const all = ExerciseStore.#load()
    exercise.id = crypto.randomUUID()
    exercise.deletedAt = null
    all.push(exercise)
    ExerciseStore.#save(all)
    return exercise
  }

  static update(exercise) {
    const all = ExerciseStore.#load()
    const idx = all.findIndex(e => e.id === exercise.id)
    if (idx === -1) return null
    all[idx] = exercise
    ExerciseStore.#save(all)
    return exercise
  }

  static delete(exercise) {
    exercise.deletedAt = new Date().toISOString()
    return ExerciseStore.update(exercise)
  }

  static isNameTaken(exercise) {
    const normalized = ExerciseStore.#normalize(exercise.exerciseName)
    return ExerciseStore.getAll().some(
      e => e.id !== exercise.id && ExerciseStore.#normalize(e.exerciseName) === normalized
    )
  }

  static #normalize(name) {
    return name.trim().toLowerCase().replace(/\s+/g, ' ')
  }

  static #load() {
    try {
      return JSON.parse(localStorage.getItem(ExerciseStore.#KEY) ?? '[]').map(object => new Exercise(object))
    } catch {
      return []
    }
  }

  static #save(data) {
    localStorage.setItem(ExerciseStore.#KEY, JSON.stringify(data))
  }
}

export default ExerciseStore
